import { Link } from "gatsby";
import React from "react";
import styled from "styled-components";
import BlogCarousel from "../components/BlogCarousel";
import { PrimaryButton } from "../components/Button";
import Breakpoints from "../components/styles/Breakpoints";
import { Colors } from "../components/styles/Colors";
import { Body, DomeText, Header3 } from "../components/typography";

const Wrapper = styled.div`
  color: ${Colors.cream1};
  background: ${(props) => props.color};

  overflow: hidden;

  > div {
    padding: 32px 0;
    max-width: 1600px;
    margin: 0 auto;
  }

  ${PrimaryButton} {
    color: ${(props) => props.color};
    background: ${(props) => props.btnColor};
  }

  @media ${Breakpoints.tablet} {
    > div {
      display: grid;
      grid-template-columns: 45% 55%;
    }
  }
`;

const CategoryDesc = styled.div`
  padding: 40px 32px;

  ${DomeText} {
    display: block;

    color: ${Colors.cream1};
    margin: 10px 0;
  }

  ${Body} {
    margin: 24px 0;
  }

  @media ${Breakpoints.tablet} {
    display: flex;
    flex-direction: column;

    justify-content: center;
    align-items: flex-start;

    ${Body} {
      max-width: 420px;
    }

    ${PrimaryButton} {
      width: 175px;
    }
  }
`;

function slugify(str) {
  return str
    ?.toLowerCase()
    .replace(/ /g, "-")
    .replace(/[-]+/g, "-")
    .replace(/[^\w-]+/g, "");
}

export default function BlogCategory({ category }) {
  return (
    <Wrapper
      id={slugify(category.headline)}
      color={category.color}
      btnColor={category.buttonColor}
    >
      <div>
        <CategoryDesc>
          <DomeText>{category.name}</DomeText>
          <Header3>{category.headline}</Header3>
          <Body>{category.description.description}</Body>
          <PrimaryButton as={Link} to={`/blog/${slugify(category.headline)}`}>
            View More →
          </PrimaryButton>
        </CategoryDesc>
        {category.blog_post && <BlogCarousel posts={category.blog_post} />}
      </div>
    </Wrapper>
  );
}
